<script>

import ScrollsToTarget from "../../Mixins/ScrollsToTarget.js";

export default {

    name: 'ScrollToTop',

    mixins: [ScrollsToTarget],

    props: [],

    data() {
        return {
        }
    },

    mounted() {

        this.Bus.on('scroll-to-top', () => {
            this.scrollTo(0);
        });
    },

    methods: {

    },

    computed: {

    },

    render() {}
};
</script>
